export const isEmptyContentTag = (content: string | undefined | null) =>
	!content || content === "<p></p>" || content === ""

// True when the composer HTML has a genuine user-authored body, ignoring the
// email-reply scaffold (quote + signature wrapped in [data-email-history]).
export const hasUserAuthoredBody = (content: string | undefined | null) => {
	if (isEmptyContentTag(content)) return false
	if (typeof DOMParser === "undefined") return !isEmptyContentTag(content)
	const doc = new DOMParser().parseFromString(content!, "text/html")
	doc.body.querySelectorAll("[data-email-history]").forEach((el) => el.remove())
	if ((doc.body.textContent ?? "").trim().length > 0) return true
	return doc.body.querySelector("img, video, table, a[href]") != null
}
